import React, { useState, useEffect } from "react"
import Select, { components } from "react-select"

import { sortData } from "../utils/common"
import moment from "moment-timezone"
import { put, post } from "./../utils/apiClient"
import ConfirmationModal from "./common/confirmationModal"
import AuditSearch from "./common/auditSearch"
import Pagination from "./common/pagination"

let tabs = [
  {
    key: "FAILED_FAX",
    label: "Failed Faxes",
  },
  {
    key: "RESENT_FAX",
    label: "Resent Faxes",
  },
  {
    key: "TRASH_FAX",
    label: "Trash Faxes",
  },
  {
    key: "365_DAY_FAX",
    label: "365",
  },
  {
    key: "AUDIT",
    label: "Audit",
  },
]

// ✅ Custom Option with checkbox (no blue bg)
const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => {}}
        style={{ marginRight: 8 }}
      />
      {props.label}
    </components.Option>
  )
}

// ✅ Custom ValueContainer to hide selected tags
const CustomValueContainer = ({ children, ...props }) => {
  return (
    <components.ValueContainer {...props}>
      <div style={{ fontSize: 12 }}>{props.selectProps.placeholder}</div>
      {children[1]} {/* caret/arrow */}
    </components.ValueContainer>
  )
}

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="#999" // lighter color
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 10l5 5 5-5z" />
      </svg>
    </components.DropdownIndicator>
  )
}

const FaxList = ({
  faxes,
  selectedFax,
  setSelectedFax,
  listLoading,
  fetchFaxes,
  selectedTab,
  setSelectedTab,
  setFaxes,
}) => {
  const [selectedWorkflows, setSelectedWorkflows] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [itemToDelete, setItemToDelete] = useState({})
  const [itemToUndo, setItemToUndo] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchText, setSearchText] = useState("")
  const [sortConfig, setSortConfig] = useState({
    key: "createdTimestamp",
    direction: "desc",
  })
  const [trashLoading, setTrashLoading] = useState(false)
  // const [faxesPerPage, setFaxesPerPage] = useState(3)
  // const [rowHeight, setRowHeight] = useState(20)
  const [isAuditSearch, setIsAuditSearch] = useState(false)
  const [auditListLoading, setAuditListLoading] = useState(false)
  //const faxesPerPage = 20

  // Fields to display

  let fields = []

  if (selectedTab === "AUDIT") {
    fields = [
      {
        key: "recipientName",
        label: "Recipient Name",
        sort: true,
        fixed: true,
      },
      { key: "efaxTransmissionStatus", label: "Transmission Status" },
      { key: "destFaxNum", label: "Destination", sort: true },
      { key: "completedTimestamp", label: "Completed Date", sort: true },
      { key: "sendingUser", label: "Sending User" },
      { key: "faxId", label: "Fax Id" },
      { key: "printJobId", label: "Print Job ID (Epic)" },
      // { key: "efaxStatus", label: "EFax Status" },
      { key: "pages", label: "Pages Sent", ffLabel: "Pages" },
    ]
  } else {
    fields = [
      {
        key: "recipientName",
        label: "Recipient Name",
        sort: true,
        fixed: true,
      },
      { key: "efaxTransmissionStatus", label: "Transmission Status" },
      { key: "destFaxNum", label: "Destination", sort: true },
      { key: "createdTimestamp", label: "Created Date", sort: true },
      { key: "sendingUser", label: "Sending User" },
      { key: "faxId", label: "Fax Id" },
      { key: "printJobId", label: "Print Job ID (Epic)" },
      // { key: "efaxStatus", label: "EFax Status" },
      { key: "retryAttempts", label: "Retrys" },
      { key: "pages", label: "Pages Sent", ffLabel: "Pages" },
    ]
  }

  const nonFixedKeys = fields.filter((f) => !f.fixed).map((f) => f.key)
  const [selectedFieldKeys, setSelectedFieldKeys] = useState(nonFixedKeys)

  const columnOptions = fields
    .filter((f) => !f.fixed)
    .map((f) => ({ label: f.label, value: f.key }))

  fields =
    selectedFieldKeys.length && selectedTab !== "AUDIT"
      ? fields.filter((f) => selectedFieldKeys.includes(f.key) || f.fixed)
      : fields

  // Search Filter
  const filteredFaxes = faxes?.filter((fax) => {
    const matchesSearch = Object.entries(fax).some(([key, value]) => {
      // Convert the `createdTimestamp` field to the required format
      if (key === "createdTimestamp" || key === "completedTimestamp") {
        // const formattedDateUTC = moment.utc(value).format("MM-DD-YYYY hh:mm A")

        const formattedDate = moment
          .utc(value)
          .tz("America/New_York")
          .format("MM/DD/YYYY hh:mm A")

        return formattedDate.toLowerCase().includes(searchText.toLowerCase())
      }

      // For other fields, apply standard filtering
      return value?.toString().toLowerCase().includes(searchText.toLowerCase())
    })

    // Check if the fax matches any selected workflows

    let matchesWorkflow = ""

    if (selectedTab === "365_DAY_FAX") {
      matchesWorkflow =
        selectedWorkflows.length === 0 ||
        selectedWorkflows.includes(fax.faxCategory)
    } else {
      matchesWorkflow =
        selectedWorkflows.length === 0 ||
        selectedWorkflows.includes(fax.sendingUser)
    }

    return matchesSearch && matchesWorkflow
  })

  // const pageSize = 10
  const sortedFaxes = sortData(filteredFaxes, sortConfig)
  const startIdx = (currentPage - 1) * rowsPerPage
  const currentFaxes = sortedFaxes.slice(startIdx, startIdx + rowsPerPage)
  const totalPages = Math.ceil(filteredFaxes.length / rowsPerPage)

  // Pull workflows
  let workflows = []
  if (selectedTab === "365_DAY_FAX") {
    workflows = [...new Set(faxes.map((fax) => fax.faxCategory))]
  } else {
    workflows = [...new Set(faxes.map((fax) => fax.sendingUser))]
  }

  const handleExportCsv = () => {
    // if (currentFaxes.length === 0) {
    //   toast.error("No data to export")
    //   return
    // }

    const headers = fields.map((field) => field.label)

    const rows = filteredFaxes.map((fax) =>
      fields.map((field) => {
        let value = fax[field.key]

        if (
          field.key === "createdTimestamp" ||
          field.key === "completedTimestamp"
        ) {
          value = value
            ? moment
                .utc(value)
                .tz("America/New_York")
                .format("MM/DD/YYYY hh:mm A")
            : ""
        }

        return value != null ? value : ""
      })
    )

    const csvContent = [headers, ...rows]
      .map((row) =>
        row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",")
      )
      .join("\n")

    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${selectedTab}_${moment
      .utc()
      .tz("America/New_York")
      .format("MM_DD_YYYY_hh_mm_ss")}.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  useEffect(() => {
    setCurrentPage(1)
  }, [selectedWorkflows, searchText])

  // Handlers
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }))
  }

  // const handlePrev = () => {
  //   if (currentPage > 1) setCurrentPage(currentPage - 1)
  // }

  // const handleNext = () => {
  //   if (currentPage < totalPages) setCurrentPage(currentPage + 1)
  // }

  const handleFaxClick = (fax) => {
    if (fax !== selectedFax) {
      setSelectedFax(fax)
    } else {
      setSelectedFax(null)
    }
  }

  const handleTabClick = (key) => {
    setCurrentPage(1)
    setSelectedTab(key) // Update selected tab on click
    setSelectedWorkflows([])
  }

  // Function to handle the workflow button click
  const handleWorkflowClick = (workflow) => {
    // If the workflow is already selected, remove it; otherwise, add it
    const updatedWorkflows = selectedWorkflows.includes(workflow)
      ? selectedWorkflows.filter((item) => item !== workflow)
      : [...selectedWorkflows, workflow]

    setSelectedWorkflows(updatedWorkflows)
  }

  // Function to handle trash icon click
  const handleTrashClick = (item) => {
    setItemToDelete(item)
    setShowModal(true)
  }

  const handleUndoClick = (item) => {
    setItemToUndo(item)
    setShowModal(true)
  }

  // Function to handle API call
  const handleDelete = async () => {
    try {
      setTrashLoading(true)
      await put(
        `/fax/trashFax?faxId=${itemToDelete.faxId}&selectedTab=${selectedTab}`
      )
      await fetchFaxes()

      setTrashLoading(false)
    } catch (error) {
      setTrashLoading(false)
      console.error("Error deleting item:", error)
    }
    setShowModal(false)
    resetItem()
  }

  // Function to handle API call
  const handleUndo = async () => {
    try {
      setTrashLoading(true)
      await put(
        `/fax/undoTrashFax?faxId=${itemToUndo.faxId}&selectedTab=${selectedTab}`
      )
      await fetchFaxes()

      setTrashLoading(false)
    } catch (error) {
      setTrashLoading(false)
      console.error("Error undo item:", error)
    }
    setShowModal(false)
    resetItem()
  }

  const handleAuditSearch = async (params) => {
    setIsAuditSearch(true)
    setAuditListLoading(true)
    const { date, jobId, status } = params
    try {
      const data = await post(`/fax/fetchRadiantWorkflowFaxes`, {
        minTS: (date && moment(date).format("YYYY-MM-DD")) || "",
        maxTS: (date && moment(date).format("YYYY-MM-DD")) || "",
        jobId: jobId || "",
        transmissionStatus: status || "",
      })

      setFaxes(data)
      setSelectedFax(null)
      setAuditListLoading(false)
    } catch (err) {
      console.log("-> err:", err)
      setFaxes([])
      setSelectedFax(null)
      setAuditListLoading(false)
    }
  }

  // Function to handle cancellation
  const handleCancel = () => {
    setShowModal(false)
    resetItem()
  }

  const resetItem = () => {
    setItemToDelete({})
    setItemToUndo({})
  }

  useEffect(() => {
    setIsAuditSearch(false)
    setSearchText("")
  }, [selectedTab])

  useEffect(() => {
    setCurrentPage(1)
  }, [selectedWorkflows, searchText])

  useEffect(() => {
    if (process.env.REACT_APP_ENV === "production") {
      tabs = tabs.filter((tab) => tab.key !== "AUDIT")
    }
  }, [])

  const renderDataTable = () => {
    if (!isAuditSearch && selectedTab === "AUDIT") {
      return (
        <div className="audit-search-data">
          {/* <div className="audit-search-data-empty">
            Press search to retrieve data
          </div> */}
        </div>
      )
    }

    return (
      <>
        {listLoading || auditListLoading ? (
          <div className="loading-container">
            <div className="loading-message">Loading...</div>
          </div>
        ) : (
          <>
            {/* Faxes List */}
            <div className="faxes-content">
              <div className="table-container">
                <table className="faxes-table">
                  <thead>
                    <tr>
                      {fields.map((field) => (
                        <th
                          key={field.key}
                          className="faxes-th"
                          style={{
                            cursor: "pointer",
                            ...(field.key === "pages" ||
                            field.key === "retryAttempts"
                              ? { width: "50px" }
                              : {}), // Set fixed width for 'test' key
                          }}
                          onClick={() => {
                            if (field.sort) handleSort(field.key)
                          }}
                        >
                          {field?.ffLabel && selectedTab === "FAILED_FAX"
                            ? field?.ffLabel
                            : field.label}

                          <span>
                            {field.sort
                              ? sortConfig.key === field.key
                                ? sortConfig.direction === "asc"
                                  ? " 🔼"
                                  : " 🔽"
                                : " ↕️"
                              : ""}
                          </span>
                        </th>
                      ))}
                      {/* <th className="faxes-th">Actions</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {currentFaxes.length > 0 ? (
                      currentFaxes.map((fax, i) => (
                        <tr
                          key={`${fax?.faxId}_${i}`}
                          onClick={() => handleFaxClick(fax)}
                          className={`file-item ${
                            selectedFax?.faxId === fax.faxId ? "selected" : ""
                          }`}
                        >
                          {fields.map((field) => {
                            let f = fax[field.key]

                            if (field.fixed) {
                              f = (
                                <>
                                  <span className="file-icon">
                                    <span
                                      style={{
                                        overflow: "hidden",
                                        marginRight: "5px",
                                      }}
                                      title={`${fax[field.key]}`}
                                    >
                                      {fax[field.key]}
                                    </span>

                                    {(selectedTab === "FAILED_FAX" ||
                                      (selectedTab === "365_DAY_FAX" &&
                                        fax.faxCategory === "FAILED_FAX")) && (
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation()

                                          handleTrashClick({
                                            faxId: fax.faxId,
                                            recipientName:
                                              fax?.recipientName || "",
                                          })
                                        }}
                                        style={{ cursor: "pointer" }}
                                        title="Move to Trash"
                                      >
                                        🗑️
                                      </span>
                                    )}

                                    {(selectedTab === "TRASH_FAX" ||
                                      (selectedTab === "365_DAY_FAX" &&
                                        fax.faxCategory === "TRASH_FAX")) && (
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation()

                                          handleUndoClick({
                                            faxId: fax.faxId,
                                            recipientName:
                                              fax?.recipientName || "",
                                          })
                                        }}
                                        style={{ cursor: "pointer" }}
                                        title="Undo"
                                      >
                                        ↩️
                                      </span>
                                    )}
                                  </span>
                                </>
                              )
                            } else if (
                              field?.key === "createdTimestamp" ||
                              field?.key === "completedTimestamp"
                            ) {
                              f = moment
                                .utc(fax[field.key])
                                .tz("America/New_York")
                                .format("MM/DD/YYYY hh:mm A")
                            }

                            return (
                              <td
                                key={field.key}
                                className="faxes-td"
                                style={{
                                  // height: `${rowHeight}px`,
                                  backgroundColor:
                                    fax.faxCategory === "RESENT_FAILED_FAX" &&
                                    field?.key === "recipientName"
                                      ? "lightgrey"
                                      : "",
                                }}
                                title={
                                  fax.faxCategory === "RESENT_FAILED_FAX"
                                    ? "RESENT FAILED FAX"
                                    : ""
                                }
                              >
                                {f}
                              </td>
                            )
                          })}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="100%"
                          style={{
                            textAlign: "center",
                            padding: "10px",
                            border: "1px solid #ccc",
                          }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination Controls */}
              {filteredFaxes.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <>
                    {selectedTab !== "AUDIT" && (
                      <div>
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          backspaceRemovesValue={false}
                          options={columnOptions}
                          value={columnOptions.filter((opt) =>
                            selectedFieldKeys.includes(opt.value)
                          )}
                          onChange={(selected) =>
                            setSelectedFieldKeys(selected.map((s) => s.value))
                          }
                          placeholder="Select Columns"
                          components={{
                            Option: CheckboxOption,
                            ValueContainer: CustomValueContainer,
                            ClearIndicator: null,
                            DropdownIndicator,
                          }}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: 200,
                              marginBottom: 12,
                              borderRadius: 0,
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: 28,
                              height: 28,
                              paddingTop: 0,
                              paddingBottom: 0,
                              paddingLeft: 6,
                              paddingRight: 6,
                              fontSize: 12,
                              boxShadow: "none",
                              borderRadius: 0,
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              paddingTop: 0,
                              paddingBottom: 0,
                              paddingLeft: 2,
                              paddingRight: 2,
                              height: 26,
                              borderRadius: 0,
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              height: 26,
                            }),
                            indicatorSeparator: (base) => ({
                              ...base,
                              width: 0,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 2,
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: "transparent",
                              color: "black",
                              cursor: state.isDisabled
                                ? "not-allowed"
                                : "pointer",
                              ":active": { backgroundColor: "transparent" },
                              ":hover": { backgroundColor: "transparent" },
                              fontSize: 13,
                              paddingTop: 6,
                              paddingBottom: 6,
                            }),
                          }}
                        />
                      </div>
                    )}
                  </>
                  <div
                    className="faxes-pagination"
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    {filteredFaxes.length > 0 && (
                      // <Pagination
                      //   currentPage={currentPage}
                      //   totalPages={Math.ceil(filteredFaxes.length / rowsPerPage)}
                      //   onPageChange={(p) => setCurrentPage(p)}
                      //   onRowsPerPageChange={(count) => {
                      //     setRowsPerPage(count)
                      //     setCurrentPage(1) // Reset to first page on change
                      //   }}
                      // />

                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        rowsPerPage={rowsPerPage}
                        totalRows={filteredFaxes.length}
                        onPageChange={(page) => setCurrentPage(page)}
                        onRowsPerPageChange={(count) => {
                          setRowsPerPage(count)
                          setCurrentPage(1) // Reset to first page on change
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </>
    )
  }

  return (
    <div
      className="fax-list"
      style={{ flex: `${!selectedFax ? "0 0 100%" : ""}` }}
    >
      <div style={{ height: "100%" }}>
        {/* Search Bar */}
        <div className="list-header-container">
          <div className="refresh-icon-container">
            {!["365_DAY_FAX", "AUDIT"].includes(selectedTab) ? (
              <button
                title="Click to reload files"
                className="refresh-button"
                onClick={() => {
                  setCurrentPage(1)
                  fetchFaxes(true)
                }}
              >
                ↻
              </button>
            ) : (
              <button
                title="Click to go back"
                className="refresh-button"
                onClick={() => {
                  setSelectedTab("FAILED_FAX")
                  setSelectedWorkflows([])
                }}
              >
                🔙
              </button>
            )}

            <div
              style={{
                display: "flex",
                marginRight: "20px",
              }}
            >
              <div
                className="fax-view-tabs"
                style={{
                  width: ["365_DAY_FAX", "AUDIT"].includes(selectedTab)
                    ? "150px"
                    : "",
                }}
              >
                {tabs
                  .filter((tab) =>
                    ["365_DAY_FAX", "AUDIT"].includes(selectedTab)
                      ? tab.key === selectedTab // Only return the selected tab if it's one of the two
                      : true
                  )
                  .map((tab) => (
                    <div
                      key={tab.key}
                      className={`tab ${
                        selectedTab === tab.key ? "selected" : ""
                      }`}
                      onClick={() => handleTabClick(tab.key)}
                    >
                      {tab.label}
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {selectedTab === "AUDIT" ? (
            <AuditSearch
              setFaxes={setFaxes}
              setSelectedFax={(id) => setSelectedFax(id)}
              handleAuditSearch={(data) => handleAuditSearch(data)}
            />
          ) : (
            // <div className="search-container">
            //   <input
            //     type="text"
            //     placeholder="Search..."
            //     value={searchText}
            //     onChange={(e) => setSearchText(e.target.value)}
            //     style={{ outline: "none" }}
            //   />
            // </div>

            <div className="search-container">
              <input
                type="text"
                className="search-input"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              {searchText && (
                <button className="clear-btn" onClick={() => setSearchText("")}>
                  ✖
                </button>
              )}
            </div>
          )}
        </div>

        {workflows.length > 0 && !listLoading && (
          <div style={{ display: "flex" }}>
            <div className="workflow_container">
              {/* {selectedTab !== "365_DAY_FAX" && <h5>Workflow:</h5>} */}
              {workflows.map((workflow, i) => {
                if (!workflow) return <></>

                return (
                  <button
                    key={`workflow${i}`}
                    className={`workflow-button ${
                      selectedWorkflows.includes(workflow) ? "selected" : ""
                    }`}
                    onClick={() => handleWorkflowClick(workflow)}
                  >
                    {workflow?.replace(/_/g, " ")}
                  </button>
                )
              })}
            </div>

            <button
              className="faxes-button"
              onClick={handleExportCsv}
              style={{
                marginRight: "10px",
                marginTop: "10px",
                height: "30px",
                width: "150px",
              }}
            >
              Export to CSV
            </button>
          </div>
        )}

        {renderDataTable()}
      </div>

      {/* Confirmation Modal */}
      <ConfirmationModal
        show={showModal}
        onConfirm={() => {
          if (itemToUndo?.faxId) {
            handleUndo()
          }
          if (itemToDelete?.faxId) {
            handleDelete()
          }
        }}
        onCancel={handleCancel}
        loading={trashLoading}
        message={
          itemToUndo?.faxId
            ? `Are you sure you want to move ${itemToUndo?.recipientName} back?`
            : `Are you sure you want to move ${itemToDelete?.recipientName} to trash?`
        }
        loadingMessage={
          itemToUndo?.faxId ? `Moving back...` : `Moving to trash...`
        }
      />
    </div>
  )
}

export default FaxList
